import { createSvgIcon } from '@material-ui/core/utils';

export const Customer = createSvgIcon(
  <svg viewBox="0 0 28 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0554 15.9999C18.3515 15.9999 21.8332 12.5181 21.8332 8.22211C21.8332 3.92611 18.3515 0.444336 14.0554 0.444336C9.75944 0.444336 6.27767 3.92611 6.27767 8.22211C6.27767 12.5181 9.75944 15.9999 14.0554 15.9999ZM19.8766 17.9808L16.9721 29.611L15.0277 21.3471L16.9721 17.9443H11.1388L13.0832 21.3471L11.1388 29.611L8.23427 17.9808C3.9018 18.1874 0.444336 21.7299 0.444336 26.111V28.6388C0.444336 30.249 1.75076 31.5554 3.361 31.5554H24.7499C26.3601 31.5554 27.6666 30.249 27.6666 28.6388V26.111C27.6666 21.7299 24.2091 18.1874 19.8766 17.9808Z"
      fill="currentColor"
    />
  </svg>,
  'Customer'
);
